import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_ENGINE_SCORING_GRID_QUERY = gql`
  query pagedEngineScoringGrids($pager: PagerInputNew, $filters: EngineScoringGridsFilterInput) {
    pagedEngineScoringGrids(pager: $pager, filters: $filters) {
      total
      values {
        ...engineScoringGrid
      }
    }
  }
  ${Fragments.engineScoringGrid}
`;
